import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import './VideoPreview.scss';

const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');

const VideoPreview = ({
  ariaLabel,
  className = '',
  description = null,
  modalClassName = '',
  overlay = null,
  src,
  title,
}) => {
  const [showPlayer, setShowPlayer] = useState(false);

  return (
    <>
      <button
        type="button"
        className={joinClassNames('video-preview', className)}
        aria-label={ariaLabel || `播放 ${title || '视频'}`}
        onClick={() => setShowPlayer(true)}
      >
        <video
          className="video-preview__thumbnail"
          src={src}
          muted
          playsInline
          preload="metadata"
        />
        {overlay}
      </button>

      <Modal
        show={showPlayer}
        onHide={() => setShowPlayer(false)}
        centered
        size="xl"
        className={joinClassNames('video-preview-modal', modalClassName)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title || '视频预览'}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="video-preview-modal__body">
          {description ? (
            <p className="video-preview-modal__description">{description}</p>
          ) : null}
          {showPlayer ? (
            <video
              className="video-preview-modal__media"
              src={src}
              controls
              autoPlay
              playsInline
            />
          ) : null}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VideoPreview;
